import { Button, Form, Input, Modal, Select } from 'antd';
import React, { useState } from 'react';

import { UploadImage } from '@/components/UI/UploadImage';
import type { UploadImageDataType } from '@/components/UI/UploadImage/types';

import { DUMMY_SERVICE_OPTIONS } from '../../constants';
import type { TicketCategoryTableData } from '../../types';
import styles from './index.module.scss';

type AddOrEditModalProps = {
  showModal: boolean;
  modalType: 'add' | 'edit';
  closeModal: () => void;
  editingData: TicketCategoryTableData | undefined;
};

const { Item } = Form;

export const AddOrEditModal = ({
  showModal,
  modalType,
  closeModal,
  editingData,
}: AddOrEditModalProps) => {
  const [uploadImage, setUploadImage] = useState<
    UploadImageDataType | undefined
  >(undefined);

  const onFormFinish = (formValues: TicketCategoryTableData) => {
    console.log('formValues:\n', { ...formValues, uploadImage });
  };

  const handleFormCancel = () => {
    setUploadImage(undefined);
    closeModal();
  };

  return (
    <Modal
      open={showModal}
      onCancel={handleFormCancel}
      destroyOnClose
      centered
      maskClosable={false}
      footer={null}
    >
      <h4 className={styles.modalTitle}>
        {modalType === 'add' ? '新增票券類別' : '編輯票券類別'}
      </h4>
      <Form
        layout="vertical"
        initialValues={editingData}
        onFinish={onFormFinish}
      >
        <Item label="票券名稱" name="ticketName" rules={[{ required: true }]}>
          <Input placeholder="請輸入票券名稱" />
        </Item>
        <Item
          label="所屬服務"
          name="service"
          rules={[{ required: true, message: '請選擇所屬服務' }]}
        >
          {/* TODO: 假資料選單，待改成真實資料 */}
          <Select
            placeholder="請選擇所屬服務"
            options={DUMMY_SERVICE_OPTIONS}
          />
        </Item>
        <Item label="優惠內容" name="description" rules={[{ required: true }]}>
          <Input.TextArea
            maxLength={100}
            showCount
            autoSize={{ minRows: 2, maxRows: 6 }}
            placeholder="例如：提供宅內清潔服務..."
          />
        </Item>
        <Item label="使用方法" name="terms" rules={[{ required: true }]}>
          <Input.TextArea
            maxLength={100}
            showCount
            autoSize={{ minRows: 2, maxRows: 6 }}
            placeholder="例如：可用於線上預約宅內清潔..."
          />
        </Item>
        <Item label="上傳圖片">
          <UploadImage
            imageUrl={
              uploadImage?.previewUrl || editingData?.imageUrl || undefined
            }
            onImageChange={setUploadImage}
          />
        </Item>
        <Item className={styles.actionButtons}>
          <Button
            className={styles.submitButton}
            type="primary"
            htmlType="submit"
          >
            確認
          </Button>
          <Button htmlType="button" onClick={handleFormCancel}>
            取消
          </Button>
        </Item>
      </Form>
    </Modal>
  );
};
